module.exports = __webpack_public_path__ + "static/media/icon_partner_facebook.2c58856c.svg";